/**
 * Eine einzige Kontaktadresse für alles — Support, Meldungen, Datenschutz und die Direktanfrage
 * der Städteseiten. Die Datenschutzerklärung nennt genau dieselbe Adresse; ein zweites Postfach
 * gäbe es nur auf dem Papier und liesse Anfragen verloren gehen.
 *
 * Steht hier und nicht in der SupportPage, damit eine Seite, die nur die Adresse braucht, nicht
 * den ganzen SupportPage-Container in ihren Chunk zieht.
 */
export const SUPPORT_EMAIL = 'support@cowork24.ch';

/**
 * `mailto:` link with a prefilled subject and body (RFC 6068).
 *
 * Line breaks go out as CRLF (`%0D%0A`), which is what the RFC asks for; a bare `%0A` collapses
 * the template into one line in some desktop clients. Everything is percent-encoded, so umlauts,
 * `&` and `?` inside the text cannot end the parameter early.
 *
 * @param {string} to address
 * @param {{ subject?: string, body?: string }} [fields]
 * @returns {string}
 */
export const mailtoHref = (to, { subject, body } = {}) => {
  const params = [];
  if (subject) {
    params.push(`subject=${encodeURIComponent(subject)}`);
  }
  if (body) {
    params.push(`body=${encodeURIComponent(body.replace(/\r?\n/g, '\r\n'))}`);
  }
  return `mailto:${to}${params.length > 0 ? `?${params.join('&')}` : ''}`;
};
